import { render, staticRenderFns } from "./Stocks.vue?vue&type=template&id=ae13e802&scoped=true&"
import script from "./Stocks.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Stocks.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Stocks.vue?vue&type=style&index=0&id=ae13e802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae13e802",
  null
  
)

export default component.exports